import {forwardRef, useId} from "react";
// eslint-disable-next-line no-restricted-imports -- the one place which may use the react-bootstrap FloatingLabel
import BootstrapFloatingLabel, {FloatingLabelProps} from "react-bootstrap/FloatingLabel";

/**
 * A react-bootstrap FloatingLabel which links the label to its control.
 *
 * Without a controlId, react-bootstrap renders the label without "for" and the control without id, so a screen reader
 * names the field by its placeholder, which a floating label hides. A generated id links them unless one is given.
 */
export const FloatingLabel = forwardRef<HTMLDivElement, FloatingLabelProps>(({controlId, ...props}, ref) =>
{
    const generatedId = useId();

    return <BootstrapFloatingLabel ref={ref} controlId={controlId ?? generatedId} {...props}/>;
});

FloatingLabel.displayName = "FloatingLabel";
